import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/contenttemplates",
        name: "contentTemplates",
        component: () => import("@/components/contentTemplates/_ContentTemplates.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewContentTemplatesUI,
            breadcrumbs: {
                icon: "content-templates-icon",
                paths: []
            },
            title: "navbar.contenttemplates"
        },
        props: true
    },
    {
        path: "/templates/create/html",
        name: "createHtmlTemplate",
        component: () => import("@/components/contentTemplates/_HtmlTemplateForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateContentTemplate,
            breadcrumbs: {
                icon: "content-templates-icon",
                paths: [
                    ["/contenttemplates", i18n.t("contentTemplates.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/templates/:contentTemplateId/update/html",
        name: "updateHtmlTemplate",
        component: () => import("@/components/contentTemplates/_HtmlTemplateForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateContentTemplate,
            breadcrumbs: {
                icon: "content-templates-icon",
                paths: [
                    ["/contenttemplates", i18n.t("contentTemplates.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/templates/create/fixedHtml",
        name: "createFixedHtmlTemplate",
        component: () => import("@/components/contentTemplates/_FixedHtmlTemplateForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateContentTemplate,
            breadcrumbs: {
                icon: "content-templates-icon",
                paths: [
                    ["/contenttemplates", i18n.t("contentTemplates.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/templates/:contentTemplateId/update/fixedHtml",
        name: "updateFixedHtmlTemplate",
        component: () => import("@/components/contentTemplates/_FixedHtmlTemplateForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateContentTemplate,
            breadcrumbs: {
                icon: "content-templates-icon",
                paths: [
                    ["/contenttemplates", i18n.t("contentTemplates.title")]
                ]
            }
        },
        props: true
    }
];
